export enum Breakpoint {
    MOBILE = 'MOBILE',
    MOBILE_LANDSCAPE = 'MOBILE_LANDSCAPE',
    TABLET = 'TABLET',
    TABLET_LANDSCAPE = 'TABLET_LANDSCAPE',
    DESKTOP = 'DESKTOP',
    LARGE_DESKTOP = 'LARGE_DESKTOP',
}
